import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class EmployeesModule {
    constructor() {
        this.employees = [];
        this.count = 0;
        this.axiosError = null;
    }
    setEmployees(employees) {
        this.employees = employees;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.employees;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.employees.get(options);
            this.setEmployees(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async add(employees) {
        try {
            await service.employees.add(employees);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async edit(employees) {
        try {
            await service.employees.edit(employees);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async delete(employeesId) {
        try {
            await service.employees.delete(employeesId);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], EmployeesModule.prototype, "employees", void 0);
__decorate([
    State()
], EmployeesModule.prototype, "count", void 0);
__decorate([
    State()
], EmployeesModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], EmployeesModule.prototype, "setEmployees", null);
__decorate([
    Mutation()
], EmployeesModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], EmployeesModule.prototype, "setError", null);
__decorate([
    Getter()
], EmployeesModule.prototype, "list", null);
__decorate([
    Getter()
], EmployeesModule.prototype, "total", null);
__decorate([
    Getter()
], EmployeesModule.prototype, "errorList", null);
__decorate([
    Action()
], EmployeesModule.prototype, "get", null);
__decorate([
    Action()
], EmployeesModule.prototype, "add", null);
__decorate([
    Action()
], EmployeesModule.prototype, "edit", null);
__decorate([
    Action()
], EmployeesModule.prototype, "delete", null);
